import React from 'react';
const brands = [{
  name: 'HUAWEI',
  cls: 'font-semibold tracking-[0.18em]'
}, {
  name: 'SolarEdge',
  cls: 'font-semibold tracking-tight'
}, {
  name: 'enphase',
  cls: 'font-medium lowercase tracking-tight'
}, {
  name: 'GROWATT',
  cls: 'font-bold tracking-[0.08em]'
}, {
  name: 'SMA',
  cls: 'font-bold tracking-tight'
}, {
  name: 'GoodWe',
  cls: 'font-semibold italic tracking-tight'
}, {
  name: 'Fronius',
  cls: 'font-medium tracking-tight'
}, {
  name: 'Victron',
  cls: 'font-semibold tracking-wide'
}];
export function CompatibilityStrip() {
  const loop = [...brands, ...brands];
  return <section aria-label="Compatibele omvormers" className="border-b border-line bg-canvas" data-id="element-72" data-mp="1mm10fm1v3szs">
      <div className="mx-auto flex max-w-[1440px] flex-col gap-6 px-4 py-9 sm:px-6 lg:flex-row lg:items-center lg:gap-12 lg:px-10" data-id="element-73" data-mp="1hmo6yighjno8">
        <p className="shrink-0 text-[15px] font-medium text-ink lg:w-56" data-id="element-74" data-mp="3odnkf3nc6nmr">
          Werkt met je bestaande omvormer
        </p>
        <div className="relative overflow-hidden" data-id="element-75" data-mp="3jfvuuga5zdlq">
          <ul className="marquee-track flex w-max items-center gap-14" data-id="element-76" data-mp="36zkepg2d4ekc">
            {loop.map((b, i) => <li key={`${b.name}-${i}`} aria-hidden={i >= brands.length} className={`whitespace-nowrap font-display text-2xl text-ink/35 ${b.cls}`} data-id="element-77" data-mp="3byx9qo3e0ry0" data-mpi={i}>
                {b.name}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}